import { sellCarConstant } from "../_constants/sellCar.constant"
import { sellCarService } from "../_services/sellCar.service";
import { alert } from "../_utilities/alert";

export const sellCarAction = {
    sellCar
}

function sellCar(data) {
    return (dispatch) => {
        dispatch(
            dispatchFunction({
                type: sellCarConstant.GET_SELLCAR_REQUEST,
                data: null,
            })
        );
        console.log(18,data);
        sellCarService
        .sellCar(data)
            .then(
                (response) => {
                    if (response.Status === 200) {
                        dispatch(
                            dispatchFunction({
                                type: sellCarConstant.GET_SELLCAR_SUCCESS,
                                data: response,
                            })
                        );
                        alert.success(response.Message)
                    } else {
                        dispatch(
                            dispatchFunction({
                                type: sellCarConstant.GET_SELLCAR_FAILURE,
                                data: null,
                            })
                        );
                        alert.error(response.Message);
                    }
                },
                (error) => {
                    dispatch(
                        dispatchFunction({
                            type: sellCarConstant.GET_SELLCAR_FAILURE,
                            data: error,
                        })
                    );
                    alert.error("Oops! Something went wrong!!");
                }
            )
            .catch(() => {
                alert.error("Oops! Something went wrong!!");
            });
    };
}

function dispatchFunction(data) {
    return {
        type: data.type,
        data: data.data
    }
}